export const collectRaftingDay = (day, time) => {
  return {
    type: "TEAM_LEADER_RAFTING_DAY_AND_TIME",
    day: day,
    time: time
  }
}
